import React, {useState} from 'react';

import styles from './styles/input-field.module.css';

import {ReactComponent as EyeClose} from '../../assets/login/eye-close.svg';
import {ReactComponent as EyeOpen} from '../../assets/login/eye-open.svg';

export default function InputField({ type, text, placeholder, name, value, error, message, handleChange }) {
    const [isVisible, setIsVisible] = useState(false);

    const inputType = (type === 'userId') ? 'text' : (isVisible ? 'text' : 'password');

    const toogleVisible = () => {
        setIsVisible(!isVisible);
    };

    return (
        <div className={styles.wrapper}>
            <label htmlFor={name}>{text}</label>
            <div className={styles.wrapperInput} datatype={error ? 'error' : ''}>
                <input
                    id={name}
                    type={inputType}
                    placeholder={placeholder}
                    name={name}
                    value={value}
                    onChange={handleChange}
                    autoComplete='off'
                />
                {type === 'password' &&
                    <div onClick={toogleVisible}>
                        {isVisible ? <EyeOpen /> : <EyeClose /> }
                    </div>
                }
            </div>
            <p className={styles.error}>{message}</p>
        </div>
    );
}
